// Make sure this file exists and exports the correct URL
//
// En desarrollo se respeta REACT_APP_API_URL (definido en mexabeer-front/.env)
// en vez de un puerto fijo — antes decía 'http://localhost:7002/api/v1' a mano,
// que no coincide con el backend local (puerto 5000) y hacía fallar todas las
// peticiones (categorías, productos, marcas...) sin avisar más que en la consola.
const baseURL = process.env.NODE_ENV === 'production'
  ? 'https://mexabeer-3oa6.onrender.com/api/v1'
  : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1');

export default baseURL;